import { render, staticRenderFns } from "./groupSet.vue?vue&type=template&id=20e25505&"
import script from "./groupSet.vue?vue&type=script&lang=js&"
export * from "./groupSet.vue?vue&type=script&lang=js&"
import style0 from "./groupSet.vue?vue&type=style&index=0&id=20e25505&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports